export class SubscriberUpdate {
  subscriberId: number;
  creditCardPaymentTypeId: number;
  dateAuthorized: Date;
  subscriptionId: number;
  subscriptionTypeId: number;
}
